<section class="table-wrapper">
    <div class="header">
        <h4>Curse</h4>

        <div class="header-tools">
            <app-search-bar></app-search-bar>
            <app-table-filters title="Filtrează" [routeParams]="['status', 'payedBy', 'maxHoursBefore']">
                <app-select-filter field="status" [options]="filterStatuses" placeholder="Status"></app-select-filter>
                <app-select-filter field="payedBy" [options]="filterPayedBy" placeholder="Platit cu"></app-select-filter>
                <app-select-filter field="maxHoursBefore" [options]="filterMaxHoursBefore" placeholder="Perioada"></app-select-filter>
            </app-table-filters>
        </div>

        <div class="header-overlay" *ngIf="selection.selected.length as selectedNo" fxLayout="row"
             fxLayoutAlign="space-between center">
            <span>{{selectedNo}} items selected</span>
            <button mat-icon-button matTooltip="Clear selection" (click)="clearSelection()">
                <nb-icon icon="close-outline"></nb-icon>
            </button>
        </div>
    </div>
    <div class="table-container" [nbSpinner]="isLoading" nbSpinnerStatus="primary">
        <table mat-table matSort aria-label="Users" [dataSource]="data" [matSortActive]="activeSort"
               [matSortDirection]="activeSortDirection">

            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef>
                    <mat-checkbox (change)="$event ? masterToggle($event) : null" #masterToggleCheckbox>
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()">
                    <mat-checkbox (change)="$event ? toggleCheckbox(row._id) : null"
                                  [checked]="selection.isSelected(row._id)">
                    </mat-checkbox>
                </td>
            </ng-container>

            <ng-container matColumnDef="rider">
                <th mat-header-cell *matHeaderCellDef>Client</th>
                <td mat-cell *matCellDef="let row" >
                    {{row.rider?.profile?.firstName}} {{row.rider?.profile?.lastName}}
                </td>
            </ng-container>

            <ng-container matColumnDef="driver">
                <th mat-header-cell *matHeaderCellDef>Sofer</th>
                <td mat-cell *matCellDef="let row" >
                    {{row.driver?.profile?.firstName}} {{row.driver?.profile?.lastName}}
                </td>
            </ng-container>

            <ng-container matColumnDef="location">
                <th mat-header-cell *matHeaderCellDef >Locația</th>
                <td mat-cell *matCellDef="let row">
                    De la: {{row.startLoc?.address}} <i>{{row.extraInfo}}</i><br/>
                    La: {{row.endLoc?.address}}
                </td>
            </ng-container>

            <ng-container matColumnDef="optionsInfo">
                <th mat-header-cell *matHeaderCellDef >Opțiuni</th>
                <td mat-cell *matCellDef="let row">
                    <span *ngIf="row.numberOfPassengers != null">Nr. pasageri: {{row.numberOfPassengers}}<br></span>
                    <span *ngIf="row.numberOfBags != null">Nr. bagaje: {{row.numberOfBags}}<br></span>
                    <span *ngIf="row.numberOfPassengers == null && row.numberOfBags == null">{{row.optionsInfo}}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="prices">
                <th mat-header-cell *matHeaderCellDef >Preț</th>
                <td mat-cell *matCellDef="let row">
                    <div *ngIf="authService.userCan('bookings:details')">
                        Cursă: {{row.prices?.rideFull/100 | number: '1.2-2'}} Lei<br>
                        Client: {{((row.prices?.ride || 0) + (row.prices?.tip || 0))/100 | number: '1.2-2'}} Lei <span *ngIf="row?.payment?.paidByCash">CASH</span><br>
                        <span *ngIf="row.prices?.tip">Bacșiș: {{row.prices?.tip/100 | number: '1.2-2'}} Lei<br></span>
                        <span *ngIf="row.prices?.discount">Discount: {{row.prices?.discount/100 | number: '1.2-2'}} Lei<br></span>
                        <span *ngIf="row.prices?.commission">Comision: {{row.prices?.commission/100 | number: '1.2-2'}} Lei<br></span>
                        <div *ngIf="!row?.payment?.priceRide?.status && row.prices?.correction">
                            Corecție: {{row.prices?.correction/100 | number: '1.2-2'}} Lei<br>
                        </div>
                    </div>
                    <div *ngIf="!authService.userCan('bookings:details')">
                        Cursă: {{row.prices?.rideDriver/100 | number: '1.2-2'}} Lei<br>
                        <span *ngIf="row.prices?.tip">Bacșiș: {{row.prices?.tip/100 | number: '1.2-2'}} Lei<br></span>
                        <div *ngIf="!row?.payment?.priceRide.status && row.prices?.correction">
                            Corecție: {{row.prices?.correction/100 | number: '1.2-2'}} Lei<br>
                        </div>
                    </div>
                </td>
            </ng-container>

            <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef class="cell-center">Status</th>
                <td mat-cell *matCellDef="let row; let i = index" class="cell-center">
                    <app-badge *ngIf="row.status === 'completed'" text="{{'Finalizată' + (row?.payment?.paidByCash ? ' CASH':'')}}" [status]="'success'"></app-badge>
                    <app-badge *ngIf="row.status === 'canceled'" text="Anulată" [status]="'danger'"></app-badge>
                    <app-badge *ngIf="row.status !== 'canceled' && row.status !== 'completed'" text="{{row.status}}" [status]="'warning'"></app-badge>
                    <span *ngIf="row.status === 'canceled'"><br/>Motiv: {{row.cancelReason}}</span>
                    <span *ngIf="isBookingUnpaid(row)"><br/>Plată nefinalizată*</span>
                    <app-badge *ngIf="row.status === 'completed' && row?.completedBeforePaymentOk &&
                    ((row?.payment?.ride && row?.payment?.ride?.status !== 'confirmed') ||
                    (row?.prices.correction >=0 && row?.payment?.correction?.status !== 'confirmed') || (row?.payment?.priceRide?.status !== 'confirmed'))"
                               text="Finalizată fără așteptare plată. Plată EȘUATĂ" [status]="'info'"></app-badge>
                    <app-badge *ngIf="row.status === 'completed' && row?.completedBeforePaymentOk &&
                    ((row?.payment?.ride && row?.payment?.ride?.status === 'confirmed') ||
                    (row?.prices.correction >=0 && row?.payment?.correction?.status === 'confirmed'))"
                               text="Finalizată fără așteptare plată. Plată procesată ulterior." [status]="'warning'"></app-badge>
                    <app-badge *ngIf="row.status === 'completed' && row?.completedBeforePaymentOk &&
                    (row?.prices.correction < 0
                    && row?.payment?.estimationRide?.transactionLog?.refundStatus === 'toBeRefunded')"
                               text="Returnarea banilor după corecție urmează să fie procesată." [status]="'warning'"></app-badge>
                    <app-badge *ngIf="row.status === 'completed' && row?.completedBeforePaymentOk &&
                    (row?.prices.correction < 0 && row?.payment?.estimationRide?.status === 'refunded'
                    && row?.payment?.estimationRide?.transactionLog?.refundStatus === 'refunded')"
                               text="Returnarea banilor după corecție făcută cu succes." [status]="'success'"></app-badge>
                    <app-badge *ngIf="row.status === 'completed' && row?.completedBeforePaymentOk &&
                    (row?.prices.correction < 0
                    && row?.payment?.estimationRide?.transactionLog?.refundStatus === 'refundFailed')"
                               text="A apărut o eroare la returnarea banilor după corecție." [status]="'danger'"></app-badge>
                </td>
            </ng-container>

            <ng-container matColumnDef="created">
                <th mat-header-cell *matHeaderCellDef >Data</th>
                <td mat-cell *matCellDef="let row">{{row.createdTs | date: 'short' }}</td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="cell-center">Actions</th>
                <td mat-cell *matCellDef="let row" (click)="$event.stopPropagation()" class="cell-center">
                    <button mat-icon-button matTooltip="Anulează cursa" (click)="setBookingCanceled(row._id)" class="tapp-action-button">
                        <mat-icon color="warn">close</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index"
                [routerLink]="authService.userCan('bookings:details') ? ['/admin/bookings/', row._id] : []">
            </tr>

        </table>
    </div>

    <mat-paginator [length]="dataLength" [pageIndex]="activePage" [pageSize]="activeLength"
                   [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
    </mat-paginator>


</section>
